import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  button: {
    '&.MuiButton-root.MuiButtonBase-root': {
      textTransform: 'capitalize',
      color: theme.palette.text.primary,
      fontSize: theme.spacing(1.75),
    },
  },
}));
